module.exports = __webpack_public_path__ + "static/media/star_inactive.ab594627.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/star_inactive.png
// module id = 480
// module chunks = 0